<template>
  <v-card elevation="0" outlined class="border rounded-lg mb-5 px-5">
    <v-switch
      v-model="switch1"
      inset
      label="Gebruik Kyano-Account gegevens"
    ></v-switch>
  </v-card>
</template>
<script>
export default {
    props: {
    profiles: Object,
  },
  data: () => ({}),
};
</script>

